import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const PurposeSection = () => {
  const { t } = useTranslation('common');
  return (
    <section className="bg-[#fff9ed] py-16 lg:py-24">
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Side - Comic Book Images */}
          <div className="order-2 lg:order-1">
            <div className="relative max-w-lg mx-auto">
              {/* Main Comic Book */}
              <div className="relative">
                <img 
                  src="/assets/imgs/About/Inner%20Pages_Picture_About_4.png" 
                  alt="Comic Book Cover" 
                  className="w-full max-w-sm mx-auto rounded-lg shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-300"
                />
              </div>
              
              {/* Background Comic Books */}
              
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="order-1 lg:order-2">
            {/* <p className="text-base font-semibold text-text-dark mb-2">What we do</p> */}
            <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-4">{t('about.purpose.title')}</h2>

            <p className="text-base text-text-dark leading-normal mb-4">{t('about.purpose.body')}</p>

            <h3 className="text-2xl lg:text-3xl font-bold text-text-dark mb-3">{t('about.purpose.missionTitle')}</h3>
            <p className="text-base text-text-dark leading-normal mb-4">{t('about.purpose.missionBody')}</p>

            <Link to="../shop" className="bg-brown hover:bg-brown-dark text-cream px-8 py-3 rounded text-sm font-normal uppercase tracking-wide transition-all duration-300 hover:-translate-y-1 hover:shadow-lg mt-2 inline-block">
              {t('about.shopNow')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurposeSection;
